import type { ParseOptions } from 'query-string';
import curations from '@assets/icons/catalog-curations.svg?url';

export const CATALOG_PATH = '/shop';
export const BABY_SHOP_PATH = '/shop/baby';
export const CASH_FUNDS_PUBLIC_URL_PATH = '/shop/catalog/cash-funds-gift-cards';
export const CURATIONS_PATH = '/curations';
export const BRANDS_PATH = '/brands';

export const SHIPPING_POLICY_PATH = '/shipping-policy';
export const RETURN_POLICY_PATH = '/return-policy';

export const CURATION_DEPARTMENT_ICON = curations;

export const SKELETON_ITEMS_COUNT = 5;
export const CURATION_TILE_IMAGE_COUNT = 3;

export const PRODUCT_TILE_MAX_LENGTH = 56;

export const CATALOG_PRODUCT_LIST_PAGE_SIZE = 48;

/** Curation detail pages fetch up to this many items in the first request so ~50-item curations avoid a misleading Load More. */
export const CURATION_PRODUCT_LIST_PAGE_SIZE = 100;

export const RECOMMENDED_PRODUCTS_PAGE_SIZE = 12;

export const DEFAULT_CUSTOM_ITEM_IMAGE = 'https://heygirl.cutestperson.com/assets/public/apps/registry/custom-item-default.svg';

export const CATALOG_SEARCH_ICON_BUTTON = 'catalogSearchIcon';

export const PRODUCT_FILTER_QS_PARSE_OPTIONS: ParseOptions = { arrayFormat: 'separator', arrayFormatSeparator: '|' };

export const REFINEMENT_PANEL_STICKY_THRESHOLD_CSS_VAR = '--rp-stickythreshold';
export const REFINEMENT_PANEL_TOGGLE_TOP_CSS_VAR = '--rpt-top';

export const PRODUCT_GRID_BREAKPOINTS = ['mobile', 'sm2', 'md3', 'lg', 'lg1'] as const;
export const CAROUSEL_BREAKPOINTS = PRODUCT_GRID_BREAKPOINTS;

// partially matches RegistryItemSource in registry_service
export enum RegistryItemSource {
  googleShoppingSponsored = 'googleShoppingSponsored',
  googleShoppingRegular = 'googleShoppingRegular',
  googleSearch = 'googleSearch',
  catalogSearch = 'catalogSearch',
  catalogShop = 'catalogShop',
  manual = 'manual',
  manualScanned = 'manualScanned',
  recommendedCatalogTransfer = 'recommendedCatalogTransfer',
  recommendedCatalogShop = 'recommendedCatalogShop',
  adopt = 'adopt',
  bookmarklet = 'bookmarklet',
}
